import {
  RSVPVisibilityFriends,
  RSVPVisibilityPrivate,
  RSVPVisibilityPublic,
  type RSVPVisibility,
} from '@/lib/api/apiTypes';
import AsyncStorage from '@react-native-async-storage/async-storage';

const RSVP_VISIBILITY_PREFERENCE_KEY = 'radious:rsvp-visibility-preference';

export function defaultRSVPVisibilityFromLegacyPreference(defaultRsvpPublic: boolean) {
  return defaultRsvpPublic ? RSVPVisibilityPublic : RSVPVisibilityPrivate;
}

export async function loadRSVPVisibilityPreference(defaultRsvpPublic: boolean) {
  const stored = await AsyncStorage.getItem(RSVP_VISIBILITY_PREFERENCE_KEY);
  if (
    stored === RSVPVisibilityPublic ||
    stored === RSVPVisibilityFriends ||
    stored === RSVPVisibilityPrivate
  ) {
    return stored;
  }
  return defaultRSVPVisibilityFromLegacyPreference(defaultRsvpPublic);
}

export function saveRSVPVisibilityPreference(visibility: RSVPVisibility) {
  return AsyncStorage.setItem(RSVP_VISIBILITY_PREFERENCE_KEY, visibility);
}
